import { useEffectSkipFirst, useForm } from 'utils/hooks'
import { Badge, Button, Modal, Table } from 'react-bootstrap'
import { useContext, useEffect, useState } from 'react'
import { PcrErrorForm, PcrErrorSearchForm, WellInfo } from 'entities/pcr_error'
import { useDeletePcrErrorApi, useFetchPcrErrorsApi, usePostPcrErrorApi } from 'api/pcr_error'
import { Flex } from 'components/shared/flex'
import { InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { ScaleLoader } from 'react-spinners'

type PcrErrorsProps = {
    pcrRunId?: number
    selectedWells?: WellInfo[]
    onSuccess?: () => void
}

export const PcrErrors = (props: PcrErrorsProps) => {
    const form = useForm<PcrErrorForm>({ pcrRunId: props.pcrRunId })
    const postApi = usePostPcrErrorApi()
    const globalState = useContext(GlobalStateContext)
    const searchForm = useForm<PcrErrorSearchForm>({ pcrRunId: props.pcrRunId })
    const api = useFetchPcrErrorsApi(searchForm)
    const deleteApi = useDeletePcrErrorApi()

    useEffect(() => {
        api.execute()
    }, [])

    useEffect(() => {
        form.updateObject('errorWells', props.selectedWells)
    }, [props.selectedWells])

    useEffectSkipFirst(() => {
        globalState.setLoading(postApi.loading)
        if (postApi.isSuccess()) {
            api.execute()
            if (props.onSuccess) {
                props.onSuccess()
            }
        }
    }, [postApi.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(deleteApi.loading)
        if (deleteApi.isSuccess()) {
            api.execute()
        }
    }, [deleteApi.loading])

    return (
        <>
            <div style={{ marginBottom: 20, padding: 20, backgroundColor: '#f1f1f1' }}>
                <div style={{ fontSize: 18 }}>エラー登録</div>
                <div style={{ padding: 10 }}>
                    <Flex style={{ marginBottom: 10 }}>
                        <div>選択中のWell:</div>
                        {props.selectedWells?.map((wellInfo) => {
                            return (
                                <Badge bg="primary" key={wellInfo.well}>
                                    {wellInfo.well}
                                </Badge>
                            )
                        })}
                    </Flex>
                    <InputField required form={form} attr="cause" apiError={postApi.apiError} label="原因" />
                    <InputField required form={form} attr="countermeasures" apiError={postApi.apiError} label="対応措置" />
                    <InputField form={form} attr="preventiveMeasures" apiError={postApi.apiError} label="防止策" />
                    <InputField form={form} attr="note" apiError={postApi.apiError} label="メモ" as="textarea" />
                    <Flex justifyContent="flex-end">
                        <Button
                            variant="success"
                            onClick={() => {
                                postApi.execute(form)
                            }}
                        >
                            エラー登録
                        </Button>
                    </Flex>
                </div>
            </div>

            {api.loading && (
                <Flex justifyContent="center">
                    <ScaleLoader />
                </Flex>
            )}
            {!api.loading && api.response.results.length > 0 && (
                <Table>
                    <thead>
                        <tr>
                            <th style={{ width: 60 }}>ID</th>
                            <th style={{ width: 120 }}>Staff</th>
                            <th style={{ width: 60, textAlign: 'center' }}>Well</th>
                            <th style={{ width: 180 }}>Probe</th>
                            <th style={{ width: 220 }}>cDNA ID</th>
                            <th style={{ width: 120 }}>原因</th>
                            <th style={{}}>メモ</th>
                            <th style={{ width: 80 }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {api.response.results.map((pcrError) => {
                            return (
                                <tr key={'api-error-' + pcrError.id}>
                                    <td>{pcrError.id}</td>
                                    <td>{pcrError.user?.fullName}</td>
                                    <td style={{ textAlign: 'center' }}>{pcrError.well}</td>
                                    <td>{pcrError.probeName}</td>
                                    <td>{pcrError.dnaCode}</td>
                                    <td>{pcrError.cause}</td>
                                    <td>{pcrError.note}</td>

                                    <td>
                                        <Button
                                            size="sm"
                                            variant="danger"
                                            onClick={() => {
                                                globalState.showConfirm(`ID: ${pcrError.id}のエラーを削除しますか？`, () => {
                                                    deleteApi.execute(pcrError.id!)
                                                })
                                            }}
                                        >
                                            削除
                                        </Button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            )}
        </>
    )
}

type PcrErrorProps = {
    pcrRunId: number
    selectedWells: WellInfo[]
    onSuccess?: () => void
}

const PcrErrorModal = (props: PcrErrorProps) => {
    const [show, setShow] = useState<boolean>(false)

    return (
        <>
            <Button
                variant="danger"
                onClick={() => {
                    setShow(true)
                }}
            >
                Wellエラー登録
            </Button>
            <Modal show={show} onHide={() => setShow(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>エラー</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PcrErrors {...props} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        閉じる
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default PcrErrorModal
